import {
  Component,
  ChangeDetectionStrategy,
  forwardRef,
  ChangeDetectorRef,
  inject,
  OnInit,
  input,
  viewChild,
} from '@angular/core';
import { TextBoxModule, TextBoxComponent } from '@progress/kendo-angular-inputs';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';
import { FloatingLabelComponent } from '@progress/kendo-angular-label';
import { cueIcon, IconComponent } from '@cue/ui/icons';
import { ClearableDirective } from '@cue/ui';

@Component({
  selector: 'assist-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.scss'],
  imports: [TextBoxModule, ClearableDirective, ReactiveFormsModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextboxComponent),
      multi: true,
    },
  ],
})
export class TextboxComponent implements ControlValueAccessor, OnInit {
  private cdr = inject(ChangeDetectorRef);
  public floatingLabel = inject(FloatingLabelComponent, { optional: true });
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  onChange: any = (val) => {};
  onTouch: any = (val) => {};

  textBox = viewChild<TextBoxComponent>('textBox');
  placeholder = input<string>();
  iconBefore = input<cueIcon>();
  _control = new FormControl<string>('', { nonNullable: true });
  showClear = input<boolean>();
  private _ignoreEmit: boolean = false;
  ngOnInit() {
    this._control.valueChanges.subscribe((val) => {
      if (this._ignoreEmit) {
        this._ignoreEmit = false;
      } else {
        this.onChange(val);
      }
    });
  }

  focus() {
    this.textBox().focus();
    this.cdr.markForCheck();
    this.onTouch();
    if (this.floatingLabel) {
      this.floatingLabel.focused = true;
    }
  }

  blur() {
    this.cdr.markForCheck();
    if (this.floatingLabel) {
      this.floatingLabel.focused = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this._ignoreEmit = true;
    this._control.setValue(obj);
    this.cdr.markForCheck();
  }
}
